<template>
  <PlacePage :place="place" />
</template>

<script setup lang="ts">
import { captureError } from '~/lib/logger'
import type { LanguageCodes, Place } from '~/types/api'

definePageMeta({
  layout: 'search-with-footer'
})

const { locale } = useI18n()
const geolocation = useGeolocation()
const { getPlacesApiClient } = useApiClients()

const { error: placeError, data: place } = await useAsyncData('place', async () => {
  const { data: nearbyPlaces } = await getPlacesApiClient().GET('/NearbyCities', {
    params: {
      query: {
        Latitude: geolocation?.latitude,
        Longitude: geolocation?.longitude,
        Country: getGeoCountryOrDefault(geolocation?.country),
        PlaceType: 'City',
        PageSize: 1,
        SortBy: 'DistanceAsc',
        DistanceKm: 1000,
        LanguageCode: locale.value as LanguageCodes
      }
    }
  })

  if ((nearbyPlaces?.pageSize ?? 0) <= 0) return

  return nearbyPlaces?.results?.[0] as Place
})

if (placeError.value) captureError(toRaw(placeError.value) ?? new Error('Error fetching data for places!'))
</script>
